import React, { useEffect, useState } from "react";
import { X, Trash2, Download, Loader2, Mail } from "lucide-react";
import { api, API, TOKEN_KEY } from "../../lib/api";
import { useToast } from "../../hooks/use-toast";

export default function SubscribersPanel({ onClose }) {
  const { toast } = useToast();
  const [subs, setSubs] = useState(null);

  const load = () => api.getSubscribers().then(setSubs).catch(() => setSubs([]));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    try {
      await api.deleteSubscriber(id);
      toast({ title: "נמחק", description: "הנרשם הוסר מהרשימה." });
      load();
    } catch {
      toast({ title: "שגיאה", description: "לא ניתן למחוק." });
    }
  };

  const exportCsv = async () => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const res = await fetch(`${API}/subscribers/export`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "amor_subscribers.csv";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch {
      toast({ title: "שגיאה", description: "ייצוא נכשל." });
    }
  };

  const fmt = (d) => {
    try { return new Date(d).toLocaleDateString("he-IL"); } catch { return ""; }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start md:items-center justify-center overflow-y-auto p-4">
      <div className="w-full max-w-lg bg-white my-8 rounded-md overflow-hidden">
        <div className="flex items-center justify-between border-b border-neutral-200 px-6 py-4">
          <div className="flex items-center gap-2">
            <Mail className="h-5 w-5 text-neutral-700" />
            <h2 className="font-display text-xl tracking-wide">רשימת תפוצה</h2>
          </div>
          <button onClick={onClose} className="text-neutral-500 hover:text-black">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="px-6 py-4 flex items-center justify-between border-b border-neutral-100">
          <span className="text-sm text-neutral-500">
            {subs ? `${subs.length} נרשמים` : "טוען..."}
          </span>
          <button
            onClick={exportCsv}
            disabled={!subs || subs.length === 0}
            className="flex items-center gap-2 text-xs tracking-[0.15em] bg-black text-white px-4 py-2 rounded-md hover:bg-neutral-800 disabled:opacity-40"
          >
            <Download className="h-4 w-4" /> ייצוא CSV
          </button>
        </div>

        <div className="max-h-[55vh] overflow-y-auto">
          {!subs ? (
            <div className="py-16 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-neutral-400" /></div>
          ) : subs.length === 0 ? (
            <p className="py-16 text-center text-sm text-neutral-500">עדיין אין נרשמים לרשימת התפוצה.</p>
          ) : (
            subs.map((s) => (
              <div key={s.id} className="flex items-center gap-3 px-6 py-3 border-b border-neutral-100 last:border-0">
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-neutral-900 truncate">{s.email}</p>
                  <p className="text-xs text-neutral-400">{fmt(s.createdAt)}</p>
                </div>
                <button onClick={() => remove(s.id)} className="p-2 text-neutral-400 hover:text-red-600" aria-label="delete">
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
